export default "__VITE_ASSET__a80eb372__"